import AutosaveSuccess from "@mui/icons-material/CheckCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@mui/material";
import { get, isEmpty } from "lodash";
import FormTitle from "../../../common/js/components/FormTitle";
import ListingCommentBlock from "../comments/ListingCommentBlock";
import ContactContainer from "../contact/ContactContainer";
import { contact_options } from "../contact/constants";
import CondoForm from "../property/CondoForm";
import EducationalForm from "../property/EducationalForm";
import HospitalityForm from "../property/HospitalityForm";
import IndustrialForm from "../property/IndustrialForm";
import LandForm from "../property/LandForm";
import MixedUseForm from "../property/MixedUseForm";
import MultifamilyForm from "../property/MultifamilyForm";
import ParkingInfoForm from "../property/ParkingInfoForm";
import PortfolioForm from "../property/PortfolioForm";
import ReligiousForm from "../property/ReligiousForm";
import RetailForm from "../property/RetailForm";
import FinancialInformation from "./FinancialInformation";
import ListingForm from "./ListingForm";

const ListingRequest = (props) => {
    const {
        autocompleteResults,
        data,
        disableInputs,
        errors,
        handleAddArrayElement,
        handleDeleteArrayElementNEW,
        handleInputChange,
        handleListingUpdateArrayElement,
        handleSearchCompany,
        handleUpdateArrayElement,
        property,
        togglePanel,
        listingRef,
        panels,
    } = props;

    const useType = get(data, "attributes.useType", false);

    const attributes = isEmpty(data.attributes) ? {} : data.attributes;
    

    return (
        <div ref={listingRef}>
            <Accordion
                expanded={panels.listingInformation}
                onChange={() => togglePanel("listingInformation", !panels.listingInformation)}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <div className="expansionPanelContentContainer">
                        <AutosaveSuccess className="waterloo" style={{ paddingTop: "4px" }} />
                        <div>
                            Listing Information
                            <div>
                                <small className="entityIDText">Listing ID: {data.listingKey}</small>
                            </div>
                        </div>
                    </div>
                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <ListingForm
                        {...props}
                        showListingExpiration={true}
                        disabled={false}
                        listing={data}
                        errors={get(errors, "listing", {})}
                        handleInputChange={handleInputChange}
                        propertyType={get(property, "propertyType", null)}
                    />
                    <Divider />
                    <MixedUseForm
                        {...props}
                        handleDeleteArrayElement={handleDeleteArrayElementNEW}
                        handleUpdateArrayElement={handleListingUpdateArrayElement}
                        onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                        data={attributes}
                        dataPathPrefix="attributes"
                        errors={get(errors, "listing.attributes", {})}
                    />
                    <Divider />
                    <PortfolioForm
                        {...props}
                        handleDeleteArrayElement={handleDeleteArrayElementNEW}
                        handleUpdateArrayElement={handleListingUpdateArrayElement}
                        onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                        data={attributes}
                        dataPathPrefix="attributes"
                        errors={get(errors, "listing.attributes", {})}
                    />
                    <Divider />
                    <CondoForm
                        {...props}
                        handleDeleteArrayElement={handleDeleteArrayElementNEW}
                        handleUpdateArrayElement={handleListingUpdateArrayElement}
                        onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                        data={attributes}
                        dataPathPrefix="attributes"
                        errors={get(errors, "listing.attributes", {})}
                    />
                    <Divider />
                    <FormTitle title="Parking Information" />
                    <ParkingInfoForm
                        {...props}
                        errors={get(errors, "listing.attributes", {})}
                        context="listing"
                        data={attributes}
                        useType={useType}
                        onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                    />
                    {useType === "Retail" && (
                        <div>
                            <Divider />
                            <FormTitle title="Retail Information" />
                            <RetailForm
                                {...props}
                                handleUpdateArrayElement={handleListingUpdateArrayElement}
                                handleDeleteArrayElement={handleDeleteArrayElementNEW}
                                context="listing"
                                onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                                data={attributes}
                                errors={get(errors, "listing.attributes", {})}
                                dataPathPrefix="attributes"
                            />
                        </div>
                    )}
                    {useType === "Industrial" && (
                        <div>
                            <Divider />
                            <FormTitle title="Industrial Information" />
                            <IndustrialForm
                                {...props}
                                errors={get(errors, "listing.attributes", {})}
                                context="listing"
                                onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                                data={attributes}
                            />
                        </div>
                    )}
                    {useType === "Land" && (
                        <div>
                            <Divider />
                            <FormTitle title="Land Information" />
                            <LandForm
                                {...props}
                                errors={get(errors, "listing.attributes", {})}
                                context="listing"
                                onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                                data={attributes}
                            />
                        </div>
                    )}
                    {useType === "Multifamily" && (
                        <div>
                            <Divider />
                            <FormTitle title="Multifamily Information" />
                            <MultifamilyForm
                                {...props}
                                errors={get(errors, "listing.attributes", {})}
                                context="listing"
                                onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                                data={attributes}
                            />
                        </div>
                    )}
                    {useType === "Hospitality" && (
                        <div>
                            <Divider />
                            <FormTitle title="Hospitality Information" />
                            <HospitalityForm
                                {...props}
                                errors={get(errors, "listing.attributes", {})}
                                context="listing"
                                onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                                data={attributes}
                            />
                        </div>
                    )}
                    {useType === "Religious" && (
                        <div>
                            <Divider />
                            <FormTitle title="Religious Information" />
                            <ReligiousForm
                                {...props}
                                errors={get(errors, "listing.attributes", {})}
                                context="listing"
                                onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                                data={attributes}
                            />
                        </div>
                    )}
                    {useType === "Educational" && (
                        <div>
                            <Divider />
                            <FormTitle title="Educational Information" />
                            <EducationalForm
                                {...props}
                                errors={get(errors, "listing.attributes", {})}
                                context="listing"
                                onChange={(field, value) => handleInputChange("listing.attributes." + field, value)}
                                data={attributes}
                            />
                        </div>
                    )}
                </AccordionDetails>
            </Accordion>
            <Accordion
                expanded={panels.listingFinancial}
                onChange={() => togglePanel("listingFinancial", !panels.listingFinancial)}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <div className="expansionPanelContentContainer">
                        <AutosaveSuccess className="waterloo" style={{ paddingTop: "4px" }} />
                        <div>Listing Financial Information</div>
                    </div>
                </AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <FinancialInformation
                        {...props}
                        disableInputs={disableInputs}
                        listing={data}
                        errors={get(errors, "listing", {})}
                        handleInputChange={handleInputChange}
                    />
                </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded className="expansionPanelBorder">
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <div>
                        Contact Information{" "}
                        <small style={{ fontSize: "13px", color: "#999", fontWeight: "600" }}>
                            (Building Owner, Property Manager, Outside Broker, etc.)
                        </small>
                    </div>
                </AccordionSummary>
                <Divider />
                {disableInputs && isEmpty(get(data, "attributes.contacts", [])) && (
                    <div style={{ textAlign: "center", paddingTop: "15px" }}>No Listing Contacts Provided</div>
                )}
                {(!disableInputs || !isEmpty(get(data, "attributes.contacts", []))) && (
                    <AccordionDetails>
                        <ContactContainer
                            {...props}
                            autocompleteResults={autocompleteResults}
                            handleSearchCompany={handleSearchCompany}
                            handleChange={(field, value, index) =>
                                handleUpdateArrayElement("listing.attributes.contacts", index, field, value)
                            }
                            handleAdd={() => handleAddArrayElement("attributes.contacts")}
                            handleDelete={(index) => handleDeleteArrayElementNEW("attributes.contacts", index)}
                            contacts={get(data, "attributes.contacts", [])}
                            contactTypeOptions={contact_options}
                            addButtonText="Add Contact Information"
                            includeInvoiceRecipientCheckbox={false}
                            maxContacts={5}
                            displayWhenEmpty={true}
                            companyFieldAvailable={true}
                            errors={errors}
                            disableInputs={disableInputs}
                            hideTitle={true}
                            freeFormCompany={true}
                        />
                    </AccordionDetails>
                )}
            </Accordion>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>Listing Comments</AccordionSummary>
                <Divider />
                <AccordionDetails>
                    <ListingCommentBlock
                        errors={errors}
                        handleInputChange={handleInputChange}
                        data={data}
                        disableInputs={disableInputs}
                        showFormTitle={false}
                    />
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default ListingRequest;
